import { render } from "./tab_101.vue?vue&type=template&id=790d0995&lang=pug"
import script from "./tab_101.vue?vue&type=script&lang=js"
export * from "./tab_101.vue?vue&type=script&lang=js"

import "./tab_101.vue?vue&type=style&index=0&id=790d0995&lang=css"

import exportComponent from "/Users/trevorseo/work/chekt-app-monitoring/hosting/monitoring/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTab from 'quasar/src/components/tabs/QTab.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTab});
